import React, { PropTypes } from "react";
import { Scrollbars } from "react-custom-scrollbars";

import { RectangleSpinner } from "../../../../common/spinners";
import { NotesLineItem } from "./";

const NotesList = (props) => {
  return (
    <div className={`notes-scroll full-height ${!props.paneOpen && "hidden-display"}`}>
      {(!!props.followUps && (
        <Scrollbars autoHide={true}>
          <div className="notes-list">
            {props.followUps.map((followUp) => (
              <NotesLineItem
                key={followUp.followUpId}
                type={props.type}
                followUp={followUp}
                updateNote={props.updateNote}
                createEditableFollowUpModel={props.createEditableFollowUpModel}
                needsActiveProperty={props.needsActiveProperty}
              />
            ))}
          </div>
        </Scrollbars>
      )) || <RectangleSpinner />}
    </div>
  );
};

NotesList.propTypes = {
  createEditableFollowUpModel: PropTypes.func.isRequired,
  followUps: PropTypes.array,
  type: PropTypes.string,
  updateNote: PropTypes.func.isRequired,
  needsActiveProperty: PropTypes.bool,
  paneOpen: PropTypes.bool
};

export default NotesList;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/notes/NotesList.js